import {useBreakpointValue} from '@chakra-ui/react'

const MOBILE_MEDIA_QUERY = '(max-width: 767px)'

export function isMobile() {
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches
}

export function useIsMobile() {
  return useBreakpointValue({base: true, md: false}) ?? isMobile()
}
